// extracted by mini-css-extract-plugin
export var carouselWrapperStyle = "carousel_new-module--carouselWrapperStyle--QWReb";
export var control = "carousel_new-module--control--jHgTo";
export var controls = "carousel_new-module--controls--obtkm";